import React, { useState, useMemo, useEffect, useCallback } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  IconButton,
  FormControl,
  InputLabel,
  Box,
  Tooltip,
  InputAdornment,
  Divider,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Stack,
  Tabs,
  Tab,
  Typography,
  ListItemText,
  Radio,
  RadioGroup,
  FormControlLabel,
  Collapse,
  Link,
  ListSubheader,
  useTheme,
} from "@mui/material";
import { TopicChip as Chip } from "../topicChip";
import { getNumeric, getSalutationSettings, convertArrayToDictionary } from "../../../../common/utils";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import TuneIcon from "@mui/icons-material/Tune";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import _ from "lodash";
import AddPrompt from "./addPrompt";
import LogDrawer from "./logDrawer";
import GenerateResponse from "./generateResponse";
import PromptSettings from "../promptSettings";
import ReactJson from "react-json-view";
import { isValidJSON } from "./reviewUtils";
import moment, { ISO_8601 } from "moment";
import EditPrompts from "../../modals/EditPrompts";
import { useDispatch, useSelector } from "react-redux";
import { reviewsSelector } from "../../../../store/slices/reviews";
import { companiesSelector } from "../../../../store/slices/company";
import { getPromptPreview, promptsSelector, setSelectedPromptData } from "../../../../store/slices/prompts";
import { logSelector } from "../../../../store/slices/logs";
import PromptSelectDropdown from "../promptComponents/promptSelectDropdown";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-handlebars";
import "ace-builds/src-noconflict/theme-textmate";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/theme-xcode";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/ext-searchbox";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useNavigate } from "react-router";

const CustomPrompt = ({
  promptTemplates,
  requestId,
  prompt,
  reviewSelectionType,
  selectedTab,
  handleTabChange,
  openDrawer,
  toggleDrawer,
  gptUsage,
  selectedReviewText,
  promptName,
  setPromptName,
  responsePrompts,
  setPromptId,
  setPromptType,
  handleOpenWarning,
  handleOpen,
  openSliderMenu,
  jsonResponseSchema,
  setJsonResponseSchema,
  handleSliderMenuClose,
  anchorEl,
  llm,
  setLlm,
  cached,setCached,
  web_search, setWeb_search,
  presencePenalty,
  selectedLengthValue,
  setSelectedToneValue,
  setPresencePenalty,
  temperature,
  seed, setSeed,
  setTemperature,
  frequencyPenalty,
  setFrequencyPenalty,
  maxLength,
  setMaxLength,
  inputFactor,
  setInputFactor,
  jsonResponse,
  setJsonResponse,
  topP,
  setTopP,
  customSettings,
  setCustomsettings,
  setPrompt, systemPrompt, setSystemPrompt,
  handleSliderMenuOpen,
  selectedToneValue,
  setSelectedLengthValue,
  previewK,
  setPreviewK,
  systemPromptPreviewK, setSystemPromptPreviewK,
  isHovered,
  handleCopyClick,
  setIsHovered,
  handleReponseGenerateButton,
  executePromptMultiple,
  isSentiment,
  tabValue,
  handleResponseTabChange,
  tokens,
  vanillaCache,
  sentimentCache,
  text,
  setText,
  setIsHovered2,
  cache,
  isHovered2,
  handleOutputCopyClick,
  selectedReviewIds,
  handleClose,
  selectedCompany,
  openWarning,
  handleDelete,
  handleCloseWarning,
  open,
  isReviews,
  isPrompt,
  formattedData,
  companyTopics,
  handleStyleClick,
  selectedStyle,
  setTopicType,
  topicType,
  promptId,
  setFinalK,
  buttonText = 'Submit', boxHeight,
  promptsInput = {},
  chatData = false,
  verbosity,
  setVerbosity,
  reasoning_effort,
  setReasoningEffort,
  responseApi,
  setResponseApi,
  api,
  setApi,
  isTopPChecked, setIsTopPChecked,
  isTemperatureChecked, setIsTemperatureChecked,
  selectedThen, setSelectedThen,
  setPromptTab
}) => {

  const { loadingReviews } = useSelector(reviewsSelector)
  const { companies } = useSelector(companiesSelector);
  const [selectedPrompt, setSelectedPrompt] = useState('')
  useEffect(() => setSelectedPrompt(_.find(responsePrompts, it => it?.name === promptName)), [promptName, chatData, responsePrompts])
  const [collapseState, setCollapseState] = useState(false)
  const dispatch = useDispatch()
  const [openEditPromptModal, setOpenEditPromptModal] = useState(false)
  const { promptPreview, systemPromptPreview } = useSelector(promptsSelector)
  const [previewText, setPreviewText] = useState('')
  const [systemPromptPreviewText, setSystemPromptPreviewText] = useState('')
  const { gptUsage: gptUsageData, loading } = useSelector(logSelector);
  const [cursorPositions, setCursorPositions] = useState({
    0: { row: 0, column: 0 }, 
    1: { row: 0, column: 0 }, 
    2: { row: 0, column: 0 }, 
  });
  const [findOpenTabs, setFindOpenTabs] = useState(false);
  const theme = useTheme();
  
  useEffect(() => {
    setPreviewText(_.trim(promptPreview))
    if (setFinalK) {
      setFinalK((_.trim(systemPromptPreview? _.trim(systemPromptPreview) + "\n\n" + _.trim(promptPreview) : promptPreview? _.trim(promptPreview) : '')))
    }
  }, [promptPreview])

  useEffect(() => {
    const preview = promptPreview + (systemPromptPreview ? (systemPromptPreview) : '')
    setSystemPromptPreviewText(_.trim(_.split(systemPromptPreview, "\n").map(line => _.trim(line)).join("\n")))
    if (setFinalK) {
      setFinalK(_.trim(systemPromptPreview? _.trim(systemPromptPreview) + "\n\n" + _.trim(promptPreview) : promptPreview? _.trim(promptPreview) : ''))
    }
  }, [systemPromptPreview])

  const companyDic = React.useMemo(() => convertArrayToDictionary(companies, 'companyId'), [companies])
  const companyData = React.useMemo(
    () => companyDic?.[selectedCompany],
    [companyDic, selectedCompany]
  );



  const topicManagement = (value) => {
    switch (value) {
      case "Comma Separated Topics":
        return companyTopics
          ?.map((topic) => topic?.name.split("-")[0])
          .join(", ");
      case "Category And Topics":
        const result = _.map(formattedData, (value, key) => {
          return `${key}: ${value
            .map((childTopic) => childTopic.split("-")[0])
            .join(", ")}`;
        });
        return _.join(result, "\n");
      case "Context Topics":
        const resultContext = _.map(formattedData, (value, key) => {
          return `${key}\n ${value
            .map((childTopic) => {
              const splitTopic = childTopic.split("-");
              const topic = splitTopic[0];
              const description =
                splitTopic[1] === "null" ? "No description" : splitTopic[1];
              return `${topic}: ${description}`;
            })
            .join("\n ")}\n`;
        });
        return _.join(resultContext, "\n");
      case "Category And Topics Array":
        if (Object.keys(formattedData)?.length > 0) {
          let res = [];
          const result = _.map(formattedData, (value, key) => {
            res = _.concat(res, _.map(value, it => {
              return `${key}: ${it.split("-")[0]}`;
            }))
            res = _.concat(res, `${key}: Other`);
          });
          return `[\n${_.join(res, ",")}\n]`;
        }
        return ''
      case "Category And Topics With Description Array":
        if (Object.keys(formattedData)?.length > 0) {
          let res = [];
          const result = _.map(formattedData, (value, key) => {
            res = _.concat(res, _.map(value, it => {
              return `{"Topic":"${key}: ${it.split("-")[0]}","Description":"${it.split("-")[1]}"}`;
            }))
            res = _.concat(res, `{"Topic":"${key}: Other}","Description":""}`);
          });
          return `[\n${_.join(res, ",")}\n]`;
        }
        return ''
      default:
        return "Invalid value";
    }
  };

  // const sortedPrompts = useMemo(() => responsePrompts?.sort((a, b) =>
  //   a.type.localeCompare(b.type) || a.name.localeCompare(b.name))
  //   , [responsePrompts]);
  // useEffect(() => {
  //   setPromptId(promptsSelectList?.[0]?.data?.[0]?.promptId ?? null);
  // }, [promptsSelectList, chatData])

  const tooltipText = <div style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
    {Object.keys(formattedData)?.map((category) => {
      const size = _.size(formattedData[category])
      return <div key={category} style={{ disply: 'flex' }}>
        {category}:{' '}
        {formattedData[category].map((element, index) => (
          element.split("-")[0] + (Boolean(index < (size - 1)) ? ', ' : '')
        ))}
      </div>
    })}
  </div>
  const handlePromptPreview = () => {
    const localStorageData = getSalutationSettings(selectedCompany)
    let input = {}
    if (!_.isEmpty(localStorageData)) {

      const closing = localStorageData?.Closing
      if (_.trim(closing?.text) && !_.isEmpty(_.trim(closing?.text))) {
        input['Closing'] = _.trim(closing?.text) ?? ''
      }
      input['ClosingPlacement'] = closing?.paragraph ? 'SeparateParagraph' : 'Other'
      const greeting = localStorageData?.Greeting
      if (_.trim(greeting?.text) && !_.isEmpty(_.trim(greeting?.text))) {
        const additionalText = greeting.additionalText ?? ""
        input['Greeting'] = greeting?.text === '[Name Only]' ? _.trim(additionalText) : _.trim((greeting?.text ?? "") + " " + additionalText)
      }
      input['GreetingPlacement'] = greeting?.default ? 'NameOnly' : greeting?.paragraph ? 'SeparateParagraph' : 'Other'
      const businessName = localStorageData?.BusinessName
      if (_.trim(businessName?.text) && !_.isEmpty(_.trim(businessName?.text))) {
        input['BusinessName'] = _.trim(businessName?.text) ?? ""
      }
      const contactPhrase = localStorageData?.ContactPhrase
      if (_.trim(contactPhrase?.text)) {
        input['ContactPhrase'] = _.trim(contactPhrase?.text) ?? ''
      }
      const contactInfo = localStorageData?.ContactInfo
      if (_.trim(contactInfo?.text)) {
        input['ContactInfo'] = _.trim(contactInfo?.text) ?? ''
      }
    }
    let inputValues = _.isEmpty(input) ? { ...promptsInput } : { ...promptsInput, ...input }
    if (companyData?.donotUseTranslation) {
      inputValues['DonotUseTranslation'] = 'true';
    }
    dispatch(getPromptPreview({ Prompt: previewK, inputs: inputValues }))
    dispatch(getPromptPreview({ Prompt: systemPromptPreviewK, inputs: inputValues }, 'system'))
  }
  useEffect(() => {
    if (selectedReviewIds) {
      handlePromptPreview()
    }
  }, [selectedTab, selectedReviewIds, previewK, promptsInput])
  const getFormatedText = (text, isText) => {
    try {
      if (typeof (JSON.parse(text)) === 'string')
        return JSON.parse(text)
      return isText ? text : JSON.parse(text);
    }
    catch (ex) {
      return text;
    }
  }

  const getUserId=useMemo(()=> localStorage.getItem("userId"),[])
  const gptUsageMemo = useMemo(()=> convertArrayToDictionary(gptUsageData, 'createdBy'),[gptUsageData])

  const chatDataCache = useMemo(() => {
    if (!chatData) {
      return null;
    }
    const data = executePromptMultiple?.[0] ? JSON.parse(executePromptMultiple?.[0]) : null;
    // const parsedText = text ? JSON.parse(text) : null;
    // if (data?.chat_id === parsedText?.id) {
      return data
    // }
    // return null;
  }
    , [chatData, executePromptMultiple, promptId]);

  const handlePromptChange = useCallback((value)=>{
    if(selectedTab===0){
      setSystemPrompt(value)
    }else if(selectedTab===1){
      setPrompt(value)
    }else if(selectedTab===2){
      setPreviewText(value); setFinalK(value)
    }
  }, [selectedTab])

  const aceEditorValue = useMemo(()=>{
    if(selectedTab===0){
      return systemPrompt
    }else if(selectedTab===1){
      return prompt
    }
    else if(selectedTab===2){
      return previewText
    }
  },[selectedTab, systemPrompt, prompt, previewText])

    const handleCursorChange = (selection) => {
    setCursorPositions(prev => ({
      ...prev,
      [selectedTab]: {
        row: selection.cursor.row,
        column: selection.cursor.column
      }
    }));
  };

  const navigate = useNavigate();
  const handleEditPrompt = (selectedPrompt) => {
      dispatch(setSelectedPromptData(selectedPrompt))
      navigate('/prompts');
      if(setPromptTab){
        setPromptTab(0)
      }
  }
    
  return (
    <div>
      <div
        style={{
          height: boxHeight
            ? `calc(100vh - ${boxHeight}px)`

            : "calc(100vh - 269px)",
          overflowY: "auto",
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {isReviews && (
          <div style={{ position: "relative" }}>
            <div
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <IconButton disabled sx={{ visibility: "hidden", ml: 1 }}>
                <AddIcon />
              </IconButton>
            </div>
          </div>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "16px",
          }}
        >
          <PromptSelectDropdown
            responsePrompts={responsePrompts}
            promptId={promptId}
            promptName={promptName}
            setPromptId={setPromptId}
            setPromptType={setPromptType}
            setPromptName={setPromptName}
            chatData={chatData}
            isReviews={isReviews}
            isSentiment={isSentiment}
            isPrompt={isPrompt}
            label="Prompt Name"
          />
          <Tooltip title="Settings">
            <IconButton
              fontSize="small"
              sx={{ cursor: "pointer", marginTop: "2px", marginLeft: "15px" }}
              onClick={handleSliderMenuOpen}
            >
              <TuneIcon />
            </IconButton>
          </Tooltip>
        </div>

        <Collapse in={collapseState} sx={{ width: 'calc(100% - 5px)', flexShrink: 0 }}  >
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            sx={{ borderBottom: "1px solid #888" }}
          >
            <Tab value={0} sx={{ textTransform: "none" }} label="System Prompt" />
            <Tab value={1} sx={{ textTransform: "none" }} label="User Prompt" />
            <Tab value={2} sx={{ textTransform: "none" }} label="Preview" />
            {isSentiment && (
              <Tab value={3} sx={{ textTransform: "none" }} label="Topics" />
            )}

          </Tabs>


          {(selectedTab === 0 || selectedTab === 1 || selectedTab === 2) && (
            <>
              <Stack direction="row" alignItems={"flex-start"} spacing={1}>
                <Box
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  sx={{ width: "100%", pt: 2, pb: 0.5, position: "relative" }}
                >
                  <AceEditor
                    value={selectedTab===2? ((systemPromptPreviewText ? `${systemPromptPreviewText}\n\n` : "")+ previewText):_.trim(aceEditorValue) ?? ""}
                    onChange={handlePromptChange}
                    showGutter={false}
                    name="system-prompt-editor"
                    mode="handlebars"
                    theme={theme.palette.mode === 'dark' ? 'monokai' : 'textmate'}
                    style={theme.palette.mode === 'dark' ? { backgroundColor: 'transparent' } : { backgroundColor: 'transparent' }}
                    highlightActiveLine={false}
                    wrapEnabled={true}
                    showPrintMargin={false}
                    fontSize={16}
                    width="100%"
                    height="calc(100vh - 370px)"
                    sx={{zIndex: 1}}
                    focus={true}
                    // showPrintMargin={false}
                    onCursorChange={handleCursorChange}
                    onLoad={(editor) => {
                      editor.moveCursorTo(cursorPositions?.[selectedTab]?.row ?? 0, cursorPositions?.[selectedTab]?.column ?? 0);

                      if (findOpenTabs) {
                        setTimeout(() => {
                          editor.execCommand("find");
                        }, 0);
                      }

                      editor.commands.addCommand({
                        name: "customFind",
                        bindKey: { win: "Ctrl-F", mac: "Command-F" },
                        exec: function (editor) {
                          setFindOpenTabs(true);
                          editor.execCommand("find");
                        }
                      });


                      editor.commands.addCommand({
                        name: "closeSearch",
                        bindKey: { win: "Escape", mac: "Escape" },
                        exec: function (editor) {
                          if (findOpenTabs) {
                            setFindOpenTabs(false);
                            editor.searchBox.hide();
                          }
                        }
                      });

                      const checkSearchBox = () => {
                        if (editor.searchBox) {
                          const isVisible = editor.searchBox.element &&
                            editor.searchBox.element.style.display !== 'none' &&
                            editor.searchBox.element.offsetParent !== null;

                          if (!isVisible && findOpenTabs) {
                            setFindOpenTabs(false);
                          }
                        }
                      };

                      const interval = setInterval(checkSearchBox, 100);

                      editor.on('destroy', () => clearInterval(interval));
                    }}
                    key={selectedTab}
                    setOptions={{
                      enableBasicAutocompletion: false,
                      enableLiveAutocompletion: false,
                      enableSnippets: false,
                      enableMobileMenu: false,
                      showLineNumbers: false,

                      useSoftTabs: false,
                      tabSize: 0,
                      wrap: 'free',
                      wrapMethod: 'text',
                      indentedSoftWrap: false,

                    }}

                  />
                  {isHovered && aceEditorValue?.trim() !== "" && (
                    <Box
                      sx={{ 
                        position: "absolute", 
                        top: 0, 
                        right: 5, 
                        zIndex: 0
                      }}
                    >
                      <Stack direction='row' spacing={1}>
                        <IconButton
                          size="small"
                          onClick={() => handleCopyClick(false, selectedTab === 0 ? 'systemPrompt' : selectedTab===1 ? 'userPrompt' : 'preview')}
                          sx={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
                        >
                          <Stack alignItems={'center'} justifyItems={'center'}>
                            <FileCopyIcon fontSize="small" />
                            <Typography variant="caption">Copy</Typography>
                          </Stack>
                        </IconButton>
                        {/* <IconButton 
                          onClick={() => setOpenEditPromptModal(true)}
                          sx={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
                        >
                          <Stack>
                            <BorderColorIcon fontSize="small" />
                            <Typography variant="caption">Edit</Typography>
                          </Stack>
                        </IconButton> */}
                      </Stack>
                    </Box>
                  )} 
                  {/* <TextField
                    label="System Prompt Text"
                    fullWidth
                    value={systemPrompt ?? ""}
                    onChange={(e) => setSystemPrompt(e.target.value)}
                    multiline
                    size="small"
                    rows={isPrompt ? 21.8 : 13}
                    variant="outlined"
                    margin="normal"
                    InputProps={{
                      endAdornment: isHovered && (
                        <InputAdornment
                          position="end"
                          sx={{ position: "absolute", top: 30, right: 5 }}
                        >
                          {systemPrompt?.trim() !== "" && (
                            <Stack direction='row' spacing={1}>
                              <IconButton
                                size="small"
                                onClick={() => handleCopyClick(false)}
                              >
                                <Stack alignItems={'center'} justifyItems={'center'}>
                                  <FileCopyIcon fontSize="small" />
                                  <Typography variant="caption">Copy</Typography>
                                </Stack>
                              </IconButton>
                              <IconButton onClick={() => setOpenEditPromptModal(true)}><Stack><BorderColorIcon fontSize="small" /><Typography variant="caption">Edit</Typography></Stack></IconButton>
                            </Stack>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  /> */}
                </Box>
                {/* <div style={{ marginTop: "16px" }}>
                  <IconButton
                    sx={{ height: "fit-content", visibility: "hidden" }}
                  >
                    <TuneIcon />
                  </IconButton>
                </div> */}
              </Stack>
              {/* <div
                style={{ display: "flex", justifyContent: "space-between" }}
              ></div> */}
            </>
          )}
          {/* {selectedTab === 1 && (
            <>
              <Stack direction="row" alignItems={"flex-start"} spacing={1}>
                <Box
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  sx={{ width: "100%" }}
                >
                  <TextField
                    label="Prompt Text"
                    fullWidth
                    value={prompt ?? ""}
                    onChange={(e) => setPrompt(e.target.value)}
                    multiline
                    size="small"
                    rows={isPrompt ? 21.8 : 13}
                    variant="outlined"
                    margin="normal"
                    InputProps={{
                      endAdornment: isHovered && (
                        <InputAdornment
                          position="end"
                          sx={{ position: "absolute", top: 30, right: 5 }}
                        >
                          {prompt?.trim() !== "" && (
                            <Stack direction='row' spacing={1}>
                              <IconButton
                                size="small"
                                onClick={() => handleCopyClick(false)}
                              >
                                <Stack alignItems={'center'} justifyItems={'center'}>
                                  <FileCopyIcon fontSize="small" />
                                  <Typography variant="caption">Copy</Typography>
                                </Stack>
                              </IconButton>
                              <IconButton onClick={() => setOpenEditPromptModal(true)}><Stack><BorderColorIcon fontSize="small" /><Typography variant="caption">Edit</Typography></Stack></IconButton>
                            </Stack>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <div style={{ marginTop: "16px" }}>
                  <IconButton
                    sx={{ height: "fit-content", visibility: "hidden" }}
                  >
                    <TuneIcon />
                  </IconButton>
                </div>
              </Stack>
             
            </>
          )} */}
          {/* {selectedTab === 2 && (
            <>
              <Stack direction="row" alignItems={"flex-start"} spacing={1}>
                <Box
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  sx={{ width: "100%" }}
                >
                  <TextField
                    label="Prompt Preview"
                    fullWidth
                    value={ _.trim(previewText) ?? ""}
                    onChange={(e) => { setPreviewText(e.target.value); setFinalK(e.target.value) }}
                    multiline
                    size="small"
                    rows={isPrompt ? 20 : 13}
                    variant="outlined"
                    margin="normal"
                    inputProps={{
                      sx: { whiteSpace: "pre-line", overflowWrap: "break-word" },
                    }}
                    InputProps={{
                      endAdornment: isHovered && (
                        <InputAdornment
                          position="end"
                          sx={{ position: "absolute", top: 20, right: 5 }}
                        >
                          {prompt?.trim() !== "" && (
                            <IconButton
                              size="small"
                              onClick={() => handleCopyClick(true)}
                            >
                              <FileCopyIcon size="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <div style={{ marginTop: "16px" }}>
                  <Tooltip title="Settings">
                    <IconButton
                      sx={{ height: "fit-content", visibility: "hidden" }}
                    >
                      <TuneIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </Stack>
            </>
          )} */}
          {selectedTab === 3 && (
            <>
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "white",
                  zIndex: 1,
                  lineHeight: 2,
                  marginLeft: 5,
                  marginTop: 1,
                }}
              >
                <FormControl>
                  <RadioGroup
                    row
                    onChange={(e) => setTopicType(e.target.value)}
                    value={topicType}
                    aria-labelledby="Fetch-review-modal-group"
                    name="radio-buttons-group"
                  >
                    <Tooltip title={tooltipText} arrow placement="bottom">
                      <FormControlLabel
                        value={1}
                        control={<Radio />}
                        label="Existing Topics"
                      />
                    </Tooltip>
                    <Tooltip title={tooltipText} arrow placement="bottom">
                      <FormControlLabel
                        value={2}
                        control={<Radio />}
                        label="Business"
                      />
                    </Tooltip>
                  </RadioGroup>
                </FormControl>

              </div>
              {/* <div
              style={{
                height: "calc(100vh - 705px)",
                overflow: "auto",
                marginTop: "15px",
              }}
            >
              {Object.keys(formattedData).map((parentName) => (
                <div key={parentName}>
                  <Typography
                    variant="subtitle2"
                    style={{
                      background: "#E0E0E0",
                      color: "green",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      borderRadius: 5,
                      display: "inline-block",
                      fontWeight: 400,
                    }}
                  >
                    {parentName}
                  </Typography>

                  <div
                    style={{
                      display: "flex",
                      marginLeft: "30px",
                      marginTop: "15px",
                      marginBottom: "15px",
                      flexWrap: "wrap",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                    }}
                  >
                    {formattedData[parentName].map((element, index) => (
                      <Tooltip
                        title={
                          element.split("-")[1] != "null"
                            ? element.split("-")[1]
                            : ""
                        }
                        key={index}
                      >
                        <div>
                          <Chip
                            label={element.split("-")[0]}
                            variant="outlined"
                            style={{
                              color: "green",
                              marginRight: "10px",
                              marginBottom: "10px",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </Tooltip>
                    ))}
                  </div>
                </div>
              ))}
            </div> */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "white",
                  zIndex: 1,
                  lineHeight: 2,
                  marginLeft: 5,
                  marginTop: 10,
                  marginBottom: 15,
                }}
              >
                <strong>Choose a template:</strong>
              </div>
              <div>
                <div
                  style={{
                    height: "calc(100vh - 445px)",
                    overflow: "auto",
                  }}
                >
                  {promptTemplates?.map((e, index) => (
                    <div
                      key={index}
                      onClick={() => handleStyleClick(e.value)}
                      style={{
                        border: "1px solid #ccc",
                        padding: "16px",
                        boxShadow: "rgb(0,0,0,0.1)",
                        cursor: "pointer",
                        background: selectedStyle === e.value ? "#DAE9FF" : "",
                        overflow: "auto",
                        marginBottom: "15px",
                      }}
                    >
                      <div style={{ marginBottom: 25 }}>
                        <span>{e.value}</span>
                      </div>
                      <div style={{ marginBottom: 10 }}>
                        {" "}
                        <span>{e.promptText}</span>
                      </div>
                      <div>
                        <span>
                          {/* {topicManagement(e.value)
                          ?.split("\n")
                          ?.map((line, index) => (
                            <div key={index}>{line}</div>
                          ))} */}

                          {topicManagement(e.value)
                            ?.split("\n")
                            ?.map((line, index) => (
                              <div key={index}>
                                {line}
                                {index % 2 === 0 && <br />}
                              </div>
                            ))}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </Collapse>
        <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 2 }}>
          <Link sx={{ cursor: 'pointer', width: 'fit-content' }} onClick={() => setCollapseState(prev => !prev)}>{collapseState ? 'Less Info' : 'More Info'}</Link>
          <Link sx={{ cursor: 'pointer', width: 'fit-content', display: 'flex', alignItems: 'center' }} onClick={() => handleEditPrompt(selectedPrompt)}><EditOutlinedIcon sx={{ mr: 0.5, fontSize: '16px' }} />Edit Prompt</Link>
        </Stack>

        {/* Sentiments Generate and Output Start*/}
        {(isSentiment && selectedTab !== 3 || chatData) && (
          <Stack direction="row" alignItems={"flex-start"} spacing={1} sx={{ flexShrink: 0 }}>
            <Box
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              sx={{ width: "100%" }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 1, mb: -1, flexShrink: 0, gap: '16px' }}>
                <Button
                  size="small"
                  variant="contained"
                  sx={{
                    alignSelf: "flex-start",
                    // mt: 1,
                    // mb: -1,
                    textTransform: "none",
                  }}
                  disabled={!chatData ? selectedReviewIds?.length === 0 : !chatData}
                  onClick={() => handleReponseGenerateButton(false)}
                >
                  {(isSentiment || chatData) ? "Submit (Prompt)" : 'Submit'}
                </Button>
                {(isSentiment || chatData) && <Button
                  size="small"
                  variant="outlined"
                  sx={{
                    alignSelf: "flex-start",
                    // mt: 1,
                    // mb: -1,
                    textTransform: "none",
                  }}
                  disabled={!chatData ? selectedReviewIds?.length === 0 : !chatData}
                  onClick={() => handleReponseGenerateButton(true)}
                >
                  {"Submit (Preview)"}
                </Button>}
                {!chatData && <Box sx={{ marginLeft: 2, textAlign: 'center' }}>{requestId}</Box>}
              </Box>
              <div>

                {sentimentCache
                  ? sentimentCache[selectedReviewIds[0]] && (
                    <div style={{ flex: 1, marginTop: "20px" }}>
                      {isValidJSON(sentimentCache[selectedReviewIds[0]]) ? (
                        <ReactJson
                          style={{
                            marginTop: "20px",
                            whiteSpace: "pre-wrap",
                            border: "1px solid #ccc",
                            minHeight: '100px',
                            overflow: 'auto',
                            maxHeight: '1400px'
                          }}
                          src={(() => {
                            try {
                              return getFormatedText(JSON.parse(
                                sentimentCache[selectedReviewIds[0]]
                              ));
                            } catch (error) {
                              return sentimentCache[selectedReviewIds[0]];
                            }
                          })()}
                          name={null}
                          theme="rjv-default"
                          collapsed={false}
                          enableClipboard={false}
                          displayDataTypes={false}
                        />
                      ) : (
                        <div
                          style={{
                            marginTop: "20px",
                            whiteSpace: "pre-wrap",
                            border: "1px solid #ccc",
                          }}
                        >
                          {sentimentCache[selectedReviewIds[0]]}
                        </div>
                      )}
                    </div>
                  )
                  : null}

                    {/* {chatData&&<Box sx={{ display: 'flex', alignItems:'center', gap: 3, mt: 3 }}>
                        <Typography sx={{fontSize:'15px'}}><b>Input Token:</b> { chatDataCache?.usage?.prompt_tokens ? getNumeric(chatDataCache?.usage?.prompt_tokens) : getNumeric(tokens)}</Typography>
                        <Typography sx={{fontSize:'15px'}}><b>Output Token:</b> 5,246</Typography>
                        {chatDataCache?.usage?.completion_tokens && <Typography><b>Output Token:</b> { getNumeric(chatDataCache?.usage?.completion_tokens) }</Typography>}
                    </Box>} */}
                {chatDataCache
                  ? chatDataCache && (
                    <div style={{ flex: 1, marginTop: "20px" }}>
                      {chatDataCache ? (
                        <ReactJson
                          style={{
                            marginTop: "20px",
                            whiteSpace: "pre-wrap",
                            border: "1px solid #ccc",
                            minHeight: '100px',
                            overflow: 'auto',
                            maxHeight: '1400px'
                          }}
                          src={chatDataCache}
                          name={null}
                          theme="rjv-default"
                          collapsed={false}
                          enableClipboard={false}
                          displayDataTypes={false}
                          key={promptId}
                        />
                      ) : (
                        <div
                          style={{
                            marginTop: "20px",
                            whiteSpace: "pre-wrap",
                            border: "1px solid #ccc",
                          }}
                        >
                          {chatDataCache}
                        </div>
                      )}
                    </div>
                  )
                  : null}
              </div>
            </Box>
            <div>
              <div style={{ position: "relative" }}>

                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >

                  <Box sx={{ pr: 2, width: "80px" }}>
                    {getNumeric(tokens)} tokens
                  </Box>

                  <IconButton disabled sx={{ visibility: "hidden", ml: 1 }}>
                    <AddIcon />
                  </IconButton>
                </div>
              </div>
              <Tooltip title={"Logs"}>
                <div>
                  <IconButton
                    sx={{ mt: 0.5 }}
                    size="small"
                    variant="contained"
                    onClick={() => toggleDrawer(true)}
                  >
                    <TextSnippetIcon />
                  </IconButton>
                </div>
              </Tooltip>
            </div>
          </Stack>
        )}
       
        {/* Sentiments Generate and Output  End*/}
        {isReviews && (
          <>
            <div style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Box sx={{ pr: 2 }}>{getNumeric(tokens)} tokens</Box>

                <IconButton disabled sx={{ visibility: "hidden", ml: 1 }}>
                  <AddIcon />
                </IconButton>
              </div>
            </div>
            <Button
              size="small"
              variant="contained"
              sx={{ alignSelf: "flex-start", mt: 1, mb: -1, textTransform: "none" }}
              onClick={handleReponseGenerateButton}
              disabled={selectedReviewIds?.length === 0 || loadingReviews}
            >
              Generate
            </Button>
            <Stack
              direction="row"
              alignItems={"flex-start"}
              spacing={1}
              sx={{ mt: 2, flexGrow: 1 }}
              aria-label='customized response'
            >

              {tabValue === 1 ? (
                <GenerateResponse
                  text={
                    vanillaCache[selectedReviewIds[0]]
                      ? vanillaCache[selectedReviewIds[0]]
                      : text
                  }
                  setText={setText}
                />
              ) : (
                <Box
                  onMouseEnter={() => setIsHovered2(true)}
                  onMouseLeave={() => setIsHovered2(false)}
                  sx={{ width: "100%", height: '100%' }}
                >
                  <TextField
                    label="Response"
                    fullWidth
                    value={getFormatedText(cache[selectedReviewIds] ?? "", true)}
                    multiline

                    sx={{
                      height: 'calc(100% - 30px)', "& .MuiInputBase-root": {
                        height: "100%",
                        display: "flex",
                        alignItems: "start",

                      }
                    }}
                    size="small"
                    // rows={1}
                    variant="outlined"
                    margin="normal"
                    InputProps={{
                      endAdornment: isHovered2 && (
                        <InputAdornment
                          position="end"
                          sx={{ position: "absolute", top: 20, right: 5 }}
                        >
                          {executePromptMultiple?.length > 0 && (
                            <IconButton
                              size="small"
                              onClick={handleOutputCopyClick}
                            >
                              <FileCopyIcon size="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              )}

              <Tooltip title={"Logs"}>
                <div style={{ marginTop: 16 }}>
                  <IconButton
                    size="small"
                    variant="contained"
                    onClick={() => toggleDrawer(true)}
                  >
                    <TextSnippetIcon />
                  </IconButton>
                </div>
              </Tooltip>
            </Stack>
          </>
        )}
        {/* Prompt Generate Start */}
        {isPrompt && (
          <>
            <div style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Box sx={{ pr: 2 }}>{getNumeric(tokens)} tokens</Box>

                <Tooltip title={"Logs"}>
                  <div style={{ marginTop: 3 }}>
                    <IconButton
                      size="small"
                      variant="contained"
                      onClick={() => toggleDrawer(true)}
                    >
                      <TextSnippetIcon />
                    </IconButton>
                  </div>
                </Tooltip>
              </div>
            </div>
            <Button
              size="small"
              variant="contained"
              sx={{ alignSelf: "flex-start", mt: 1, mb: -1, textTransform: "none" }}
              onClick={handleReponseGenerateButton}
              disabled={(_.find(responsePrompts, it => it.promptId === promptId)?.reviewSelectionType !== "None" && selectedReviewIds?.length === 0)}
            >
              {buttonText}
            </Button>
          </>
        )}
        {/* Prompt Generate End */}
      </div>
      {open && (
        <AddPrompt
          open={open}
          handleClose={handleClose}
          selectedCompany={selectedCompany}
          isSentiment={isSentiment}
          type="Response"
        />
      )}
      {openDrawer && <LogDrawer
        openDrawer={openDrawer}
        toggleDrawer={toggleDrawer}
        gptUsage={gptUsage}
        selectedReviewText={selectedReviewText}
        selectedReviewIds={selectedReviewIds}
        selectedCompany={selectedCompany}
      />}
      {openWarning && (
        <Dialog open={openWarning}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <Divider />
          <DialogContent>
            Are you sure you want to delete this prompt?
          </DialogContent>
          <Divider />
          <DialogActions
            sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
          >
            <Button
              onClick={handleDelete}
              variant="contained"
              size="small"
              color="error"
            >
              Delete
            </Button>
            <Button
              onClick={handleCloseWarning}
              size="small"
              variant="outlined"
              color="primary"
              sx={{ ml: 2 }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <PromptSettings
        isCustomized={true}
        isSentiment={isSentiment}
        isReviews={isReviews}
        isPrompt={isPrompt}
        openSliderMenu={openSliderMenu}
        handleSliderMenuClose={handleSliderMenuClose}
        anchorEl={anchorEl}
        params={{
          llm,
          setLlm,
          cached, setCached,
          web_search, setWeb_search,
          presencePenalty,
          selectedToneValue,
          selectedLengthValue,
          setSelectedLengthValue,
          setSelectedToneValue,
          setPresencePenalty,
          temperature,
          seed, setSeed,
          setTemperature,
          frequencyPenalty,
          setFrequencyPenalty,
          maxLength,
          setMaxLength,
          topP,
          setTopP,
          inputFactor,
          setInputFactor,
          jsonResponse,
          jsonResponseSchema,
          setJsonResponseSchema,
          setJsonResponse,
          customSettings,
          setCustomsettings,
          tabValue,
          reviewSelectionType,
          verbosity,
          setVerbosity,
          reasoning_effort,
          setReasoningEffort,
          responseApi,
          setResponseApi,
          api,
          setApi, 
          isTopPChecked, setIsTopPChecked,
          isTemperatureChecked, setIsTemperatureChecked,
        }}
      />
      {openEditPromptModal && selectedPrompt?.promptId && <EditPrompts open={openEditPromptModal} handleClose={() => setOpenEditPromptModal(false)} selectedPrompt={selectedPrompt} companyId={selectedCompany} />}
    </div>
  );
};

export default CustomPrompt;
